export default "__VITE_ASSET__B73RKRMU__"